<script lang="ts">
  import { env } from '$lib/config/env';
  import { AuthGate } from '$lib/features/auth';
  import { Editor } from '$lib/features/editor';
  import { IdentityAuth, LocalAuth } from '$lib/services/auth';

  // Locally Netlify Identity does not run, so the dev server signs everyone in as `dev`.
  const service = env.localDev ? new LocalAuth() : new IdentityAuth();
</script>

<AuthGate {service}>
  {#snippet children(account)}
    <Editor {account} />
  {/snippet}
</AuthGate>
